export default __webpack_public_path__ + "static/media/Resume.dbc7cf76.pdf";